import jQuery from 'jquery';

const $ = jQuery;

const initAccessibilityAttributes = () => {
  const venueIframeMap = $('.directions-container iframe');
  const contactIframeMap = $('.contact__content iframe');
  const menuButton = $('.mega-menu-link');
  const accordionButton = $('.uk-accordion-title button');
  const filterButton = $('.choose-button');
  
  if (venueIframeMap.length >= 1) {
    $(venueIframeMap).attr('aria-label', 'Map');
  } 

  if (contactIframeMap.length >= 1) {
    $(contactIframeMap).attr('aria-label', 'Map');
  } 

  setTimeout(function(){
    if ($('#fd-form-642d9ff300b71c2447920edf input').length >= 1) {
     $('#fd-form-642d9ff300b71c2447920edf input').each(function(){
         if ($(this).attr('type') == 'text') {
          $(this).attr('autocomplete', 'email');
         }
     });
    }
  }, 300);

  $(menuButton).on('click', function(){
    let menuID = $(this).attr('data-id');
    
    setTimeout(function(){
      if ($('.mega-menu-item-has-children[data-id="'+menuID+'"]').hasClass('mega-toggle-on')) {
        $('.mega-menu-link[data-id="'+menuID+'"]').attr('aria-expanded', 'true');
      } else {
        $('.mega-menu-link[data-id="'+menuID+'"]').attr('aria-expanded', 'false');
      }
    }, 300);
  });

  $(accordionButton).on('click', function(){
    setTimeout(function(){
      if ($('.accordion__content-block li').hasClass('uk-open')) {
        $(accordionButton).attr('aria-expanded', 'true');
      } else {
        $(accordionButton).attr('aria-expanded', 'false');
      }
    }, 300);
  });

  if (filterButton.length >= 1) {
    $(filterButton).each(function(){
      $(this).attr('listbox', 'true');
    });
  }
};

export default initAccessibilityAttributes;
